global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import "../../../../../plugins/lnk/digitalhub/assets/dist/digitalhub.js";

$(document).ready(function() {

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });
});
